import ClassroomRatios from "./ClassroomRatios";
import { useClassroomData, summaryStats, processedClassroomData } from "../../data/classroomData";
import { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import AudioAlert from "../AudioAlert";

import './ClassroomSummary.css';

interface SummaryClassroomStats {
}

const ClassroomSummary:React.FC<SummaryClassroomStats> = () => {
    const [lastShown, setLastShown] = useState<number>(0);
    
    const fetchingData = useClassroomData().isFetching
    const classroomData = useClassroomData().data

    const {sections, specialCategories, classroomOptions} = useMemo(()=> processedClassroomData(classroomData), [classroomData])

    const {
        totalStudents,
        totalActiveTeachers,
        totalTeachersOnBreak,
        totalTeachers
    } = summaryStats(sections, classroomData);

    const anyUnderstaffed = sections.some(section =>
        section.classrooms?.some(classroom => classroom.ratioStatus === 'under')
    );

    return (
        <>
            <Modal 
                show={anyUnderstaffed && lastShown < (Date.now() - 1000 * 10 * 1) && !fetchingData}
                fullscreen="sm-down"
                onHide={() => setLastShown(Date.now())}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Understaffed Classroom</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AudioAlert />   
                    <p>The following classrooms are understaffed:</p>
                    <ul>
                        {sections.flatMap(section =>
                            (section.classrooms ?? [])
                                .filter(classroom => classroom.ratioStatus === 'under')
                                .map(classroom => (
                                    <li key={classroom.id}>
                                        {classroom.name}
                                    </li>
                                ))
                        )}
                    </ul>
                    <p>Please check the classroom ratios and ensure that all classrooms are properly staffed.</p>
                </Modal.Body>
            </Modal>

            <ClassroomRatios />

            <div className="summary-counts-table">
                <h2>Summary</h2>
                <table>
                    <thead>
                    <tr>
                        <th>Total Students</th>
                        <th>Total Active Teachers</th>
                        <th>Total Teachers on Break</th>
                        <th>Total Teachers</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{totalStudents}</td>
                        <td>{totalActiveTeachers}</td>
                        <td>{totalTeachersOnBreak}</td>
                        <td>{totalTeachers}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default ClassroomSummary;